const styles = {

  systemBackground: {
    backgroundColor: "#f9fafb",
    minHeight: "100vh",
    paddingBottom: "40px"
  },

  detailHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: '0px 24px 0px 24px'
  },

  lastUpdate: {
    fontSize: "12px",
    marginTop: "4px",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },

  backButton: {
    background: "#e5e7eb",
    color: "#111827",
    padding: "8px 12px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer"
  },


  metricCardCentered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    background: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #e5e7eb"
  },

  metricTitle: {
    fontSize: "13px",
    color: "#6b7280",
    marginBottom: "15px",
    fontWeight: 500
  },

  passengerTotal: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#111827"
  },

  mainChartContainer: {
    margin: "20px 16px"
  },

  detailSection: {
    marginTop: "40px",
    marginLeft: "16px",
    marginRight: "16px"
  },

  wagonsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: "16px"
  },

  telemetryContainer: {
    marginTop: "40px",
    marginLeft: "16px",
    marginRight: "16px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "12px",
    background: "#ffffff"
  },

  telemetryScroll: {
    maxHeight: "45vh",
    overflowY: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "6px"
  },

  telemetryTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
    color: "#374151"
  },

  telemetryHeaderRow: {
    background: "#ffffff"
  },


  pageWrapper: {
    display: "flex",
    height: "100vh",
    backgroundColor: "#ede9fe"
  },

  mainContent: {
    flex: 1,
    minWidth: 0,
    overflow: "auto",
    padding: "24px",
    display: "flex",
    flexDirection: "column"
  },

  card: {
    flex: 1,
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    background: "#ffffff",
  },

  emailRow: {
    px: 3,
    pt: 2,
    pb: 0.5,
  },

  emailText: {
    color: "#6b7280",
    fontSize: "0.82rem",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  },
  headerHoras: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },

  btnRemover: {
    marginLeft: "auto",
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "4px 6px",
    borderRadius: "6px",
    cursor: "pointer"
  },
  rowTop: {
    display: "flex",
    gap: "8px",
    marginTop: "8px",
    paddingBottom: "5px"
  },
  rowMiddle: {
    display: "flex",
    gap: "12px",
    marginTop: "12px",
    alignItems: "flex-start"
  },
  layoutMain: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 260px",
    gap: "12px",
    alignItems: "start",
    "@media (max-width: 1470px)": {
      gridTemplateColumns: "1fr"
    }
  },

  leftContent: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },

  rightPanel: {
    display: "flex",
    flexDirection: "column",
    marginTop: "12px",
    "@media (max-width: 1470px)": {
      marginTop: "20px"
    }
  },
  metricsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "16px",
    marginBottom: "16px"
  },
  /* TrainStatusHeader */
  trainHeaderContainer: {
    display: "flex",
    gap: "6px",
    flexWrap: "wrap"
  },
  trainHeaderBox: {
    border: "1px solid #000",
    padding: "clamp(6px, 0.8vw, 8px) clamp(8px, 1.2vw, 12px)",
    textAlign: "center",
    flex: "1 1 clamp(70px, 8vw, 110px)",
    minWidth: "clamp(70px, 8vw, 110px)"
  },

  trainHeaderTitle: {
    fontWeight: "bold",
    fontSize: "18px"
  },

  trainHeaderSubtitle: {
    fontSize: "12px"
  },

  trainHeaderValue: {
    fontWeight: "bold"
  },

  trainHeaderBigValue: {
    fontWeight: "bold",
    fontSize: "20px"
  },

  trainHeaderOperationBox: {
    border: "1px solid #000",
    padding: "4px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minWidth: "140px"
  },

  trainHeaderOperationText: {
    fontSize: "12px",
    textAlign: "center",
    marginBottom: "4px"
  },

  trainHeaderSubBox: {
    border: "1px solid #000",
    display: "flex"
  },

  trainHeaderSubItemLeft: {
    flex: 1,
    borderRight: "1px solid #000",
    textAlign: "center",
    padding: "4px 0",
    fontSize: "12px"
  },

  trainHeaderSubItem: {
    flex: 1,
    textAlign: "center",
    padding: "4px 0",
    fontSize: "12px"
  },
  /* 🔹 EmergencyStatusGrid */
  emergencyGridContainer: {
    display: "flex",

  },

  emergencyGridLabel: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    border: "1px solid #000",
    padding: "6px 4px",
    fontSize: "12px",
    textAlign: "center",
    minWidth: "20px"
  },

  emergencyGridWrapper: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: "4px",
    border: "1px solid #000",
    padding: "4px",
    background: "#eee",
    flex: 1,
    minWidth: 0 //
  },

  emergencyGridItem: {
    border: "1px solid #000",
    textAlign: "center",
    padding: "6px 4px",
    fontSize: "11px",
    lineHeight: "1.2"
  },
  /* 🔹 BypassStatusGrid */
  bypassGridContainer: {
    display: "flex",
  },

  bypassGridLabel: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    border: "1px solid #000",
    padding: "6px 4px",
    fontSize: "12px",
    textAlign: "center",
    minWidth: "20px"
  },

  bypassGridWrapper: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "4px",
    border: "1px solid #000",
    padding: "4px",
    background: "#eee",
    flex: 1
  },

  bypassGridItem: {
    border: "1px solid #000",
    textAlign: "center",
    padding: "5px 4px",
    fontSize: "11px",
    lineHeight: "1.2",
    whiteSpace: "pre-line"
  },

  /* 🔹 TrainModePanel */
  trainModeContainer: {
    padding: "9px",
    flex: "0 0 150px"
  },

  trainModeLabel: {
    flex: 1,
    border: "1px solid #000",
    padding: "6px 8px",
    fontSize: "12px"
  },

  trainModeValue: {
    width: "60px",
    border: "1px solid #000",
    textAlign: "center",
    padding: "6px 0",
    fontSize: "12px",
    fontWeight: "bold"
  },

  trainModeLayout: {
    display: "flex",
    gap: "4px"
  },

  trainModeLabels: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: 1
  },

  trainModeValues: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "60px"
  },

  trainModeBigBox: {
    flex: 1,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize: "11px",
    fontWeight: "bold",
    padding: "6px"
  },
  /* 🔹 AlertStackPanel */
  alertStackContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flex: "0 0 220px",
    padding: '11px'
  },

  alertStackItem: {
    border: "2px solid #000",
    textAlign: "center",
    padding: "10px 6px",
    fontSize: "12px",
    fontWeight: "500",
    letterSpacing: "0.5px"
  },
  /* 🔹 TrainHVACPanel */
  trainHVACContainer: {
    display: "flex",
    gap: "8",
    padding: "10px",
    background: "#fff",
    flex: 1,
    minWidth: 0
  },
  trainHVACPassengerValue: {
    fontSize: "14px",
    minWidth: "16px",
    textAlign: "center"
  },

  trainHVACStatusLabel: {

    fontSize: "11px",
    padding: "6px",
    border: "1px solid #000",
    textAlign: "center"
  },

  trainHVACStatusValue: {
    fontSize: "11px",
    padding: "6px",
    border: "1px solid #000",
    textAlign: "center"
  },

  trainHVACGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gap: "0px",
    width: "100%"
  },

  trainHVACCardWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
  },

  trainHVACCard: {
    width: "90%",
    height: "60%",
    border: "2px solid #000",
    borderRadius: "14px",
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

  },

  trainHVACTopRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "12px"
  },

  trainHVACBottomRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },

  trainHVACBars: {
    display: "flex",
    gap: "3px"
  },

  trainHVACBar: {
    width: "8px",
    height: "18px",
    borderRadius: "1px"
  },

  trainHVACLabel: {
    marginTop: "4px",
    fontSize: "11px"
  },
  trainHVACSidebar: {
    display: "flex",
    gap: "6px",
    width: "240px"
  },

  trainHVACSidebarLabels: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flex: 1
  },

  trainHVACSidebarValues: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "100px"
  },

  trainHVACATCBox: {
    flex: 1,
    border: "1px solid #000",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "500",
    padding: "8px"
  },
  /* 🔹 DoorsMatrix */
  doorsWrapper: {

  },

  doorsHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  doorsVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  doorsLabelsColumn: {
    border: "1px solid #9ca3af",
    padding: '35px 0 0 6px'
  },

  doorsLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: "10px",
    whiteSpace: "nowrap"
  },
  doorsLabelsGrid: {
    display: "grid",
    gridTemplateRows: "repeat(5, 18px)",
    gap: "5px"
  },
  doorsSpacer: {
    height: "55px"
  },

  doorsCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    verticalAlign: "top",
    lineHeight: '16px'
  },

  doorsStack: {
    display: "flex",
    flexDirection: "column",
    gap: "3px"
  },

  doorsBox: {
    border: "1px solid #111827",
    padding: "4px",
    fontSize: "10px",
    background: "#ffffff",
    textAlign: "center"
  },

  doorsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridTemplateRows: "repeat(5, 18px)",
    gap: "5px"
  },

  doorsSquare: {
    width: "100%",
    height: "18px",
    border: "1px solid #111827"
  },

  doorsDoorBox: {
    border: "1px solid #111827",
    padding: "6px",
    borderRadius: "6px",
    textAlign: "center",
    background: "#fff"
  },

  doorsDoorTop: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "10px"
  },

  doorsDoorBottom: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "10px",
    marginTop: "4px"
  },
  /* 🔹 PantographMatrix */
  pantographWrapper: {

  },

  pantographTable: {
    borderCollapse: "collapse",
    width: "100%",
    fontSize: "11px",
    tableLayout: "fixed"
  },

  pantographHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  pantographVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  pantographLabel: {


    border: "1px solid #9ca3af"
  },

  pantographCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    height: "110px",
    verticalAlign: "top"
  },

  pantographStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingTop: "6px",
    gap: "6px"
  },

  pantographIconRow: {
    display: "flex",
    gap: "42px"
  },

  pantographGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2px"
  },

  pantographIconRow: {
    display: "flex",
    gap: "clamp(12px, 3vw, 42px)"
  },
  pantographStatusContainer: {
    display: "flex",
    gap: "clamp(6px, 1.5vw, 12px)",
    justifyContent: "center",
    alignItems: "flex-start"
  },
  pantographBox: {
    border: "1px solid #111827",
    padding: "clamp(2px, 0.4vw, 3px) clamp(4px, 0.8vw, 4px)",
    fontSize: "clamp(9px, 0.9vw, 6px)",
    background: "#ffffff"
  },

  pantographTriangleUpGreen: {
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: "14px solid #22c55e"
  },

  pantographTriangleDownRed: {
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: "14px solid #ef4444"
  },

  pantographTriangleUp: {
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: "14px solid #cccecd"
  },

  pantographTriangleDown: {
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: "14px solid #cccecd"
  },
  /* 🔹 TractionMatrix */
  tractionWrapper: {

  },

  tractionHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  tractionVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  tractionLabel: {

    border: "1px solid #9ca3af"
  },

  tractionCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    verticalAlign: "top",
  },

  tractionStack: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },

  tractionBox: {
    border: "1px solid #111827",
    padding: "4px",
    fontSize: "10px",
    background: "#ffffff",
    textAlign: "center"
  },
  /* 🔹 BrakeMatrix */
  brakeWrapper: {

  },

  brakeHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  brakeVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  brakeLabelsColumn: {

    border: "1px solid #9ca3af",
    padding: "6px"
  },

  brakeGroup: {
    marginBottom: "20px"
  },

  brakeGroupTitle: {
    fontWeight: "500",
    fontSize: "11px"
  },

  brakeCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    verticalAlign: "top",
  },

  brakeStack: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },

  brakeBox: {
    border: "1px solid #111827",
    padding: "4px",
    fontSize: "10px",
    background: "#ffffff",
    textAlign: "center"
  },
  /* 🔹 DerailmentMatrix */
  derailmentWrapper: {

  },


  derailmentHeader: {
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  derailmentVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  derailmentLabel: {
    borderLeft: "1px solid #9ca3af",
    borderRight: "1px solid #9ca3af",
    padding: "6px"
  },

  derailmentCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
  },

  derailmentSquareGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "4px"
  },

  derailmentSquare: {
    width: "16px",
    height: "16px",
    border: "1px solid #111827",
    background: "#fff"
  },
  /* 🔹 FireMatrix */
  fireWrapper: {

  },


  fireHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  fireVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  fireLabel: {
    borderLeft: "1px solid #9ca3af",
    borderRight: "1px solid #9ca3af",
    padding: "6px"
  },

  fireCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    verticalAlign: "top",
    textAlign: "center"
  },

  fireBox: {
    border: "1px solid #111827",
    padding: "4px",
    fontSize: "10px",
    background: "#ffffff"
  },
  /* 🔹 EmergencyMatrix */
  emergencyMatrixWrapper: {

  },

  emergencyMatrixHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  emergencyMatrixVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  emergencyMatrixLabel: {
    borderLeft: "1px solid #9ca3af",
    borderRight: "1px solid #9ca3af",
    padding: "6px"
  },

  emergencyMatrixCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    verticalAlign: "top",
    textAlign: "center"
  },

  emergencyMatrixSquareGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "4px"
  },

  emergencyMatrixSquare: {
    width: "16px",
    height: "16px",
    border: "1px solid #111827",
    background: "#fff"
  },

  emergencyMatrixAlertBox: {
    border: "1px solid #111827",
    padding: "4px",
    fontSize: "10px",
    background: "#ffffff"
  },
  /* 🔹 FailureMatrix */
  failureWrapper: {

  },


  failureHeader: {
    background: "#cfd3d8",
    border: "1px solid #9ca3af",
    padding: "6px",
    textAlign: "center"
  },

  failureVertical: {
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    background: "#9ca3af",
    color: "#fff",
    border: "1px solid #6b7280",
    textAlign: "center",
    fontWeight: "600"
  },

  failureLabel: {
    borderLeft: "1px solid #9ca3af",
    borderRight: "1px solid #9ca3af",
    padding: "6px"
  },

  failureCell: {
    background: "#e5e7eb",
    borderRight: "3px solid #ffffff",
    padding: "6px",
    verticalAlign: "top",
    textAlign: "center"
  },

  failureBadge: {
    background: "#111827",
    color: "#fff",
    fontSize: "10px",
    padding: "2px 6px",
    marginRight: "4px"
  },

  failureBadgeLight: {
    fontSize: "10px",
    padding: "2px 6px"
  },
  miniMap: {

    container: {
      background: "#fff",
      border: "1px solid #d1d5db",
      borderRadius: "12px",
      padding: "12px"
    },

    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px"
    },

    title: {
      fontWeight: 700,
      fontSize: "16px"
    },

    subtitle: {
      fontSize: "11px",
      color: "#6b7280"
    },

    mapWrapper: {
      position: "relative",
      height: "150px",
      overflow: "hidden",
      borderRadius: "10px",
      background: "#eef2f7"
    },

    mapImage: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      filter:
        "grayscale(100%) contrast(1.1)"
    },

    overlay: {
      position: "absolute",
      inset: 0,
      background:
        "rgba(255,255,255,.45)"
    },

    lineSvg: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%"
    },

    station: {
      position: "absolute",
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      background: "#fff",
      border: "2px solid #00a651",
      transform:
        "translate(-50%,-50%)",
      zIndex: 2
    },

    trainMarker: {
      position: "absolute",
      width: "34px",
      height: "34px",
      borderRadius: "50%",
      background: "#2563eb",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform:
        "translate(-50%,-50%)",
      border: "3px solid white",
      boxShadow:
        "0 4px 12px rgba(0,0,0,.25)",
      zIndex: 3
    },

    footer: {
      marginTop: "10px",
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12px"
    }
  }
};
export default styles;